import React, {memo} from "react"
import {MANIFEST} from "@manifest/product-summary"
import {formatTextTestIds} from "@next/utils"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

interface BundleTitleProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    title: string
    tooltipTitle: string
}

export const BundleTitle = memo(({templating, title, tooltipTitle}: BundleTitleProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <ComponentName
            variant="body1"
            title={tooltipTitle}
            data-testid={formatTextTestIds(`bundle_summary_title`)}
            data-label={title}
            data-desc={title}
            data-usespan="False"
        >
            {title}
        </ComponentName>
    )
})
BundleTitle.displayName = "BundleTitle"

export default connect(BundleTitle)
